<template>
  <div id="app">
    <Header @changeMenu="toggleMenu"/>
    <Menu v-show="menuOpen" @changeMenu="toggleMenu"/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Menu from './components/Menu.vue'
import Footer from './components/Footer.vue'
import Home from './components/Home.vue'

export default {
  data(){
    return{
      menuOpen: false
    }
  },
  name: 'app',
  components: {
    Header, Menu, Home, Footer
  },
  methods:{
    toggleMenu(){
      this.menuOpen = !this.menuOpen;
    }
  }
}
</script>

<style>
body{font-size: 10px; color: #2c3136;}
p, li{font-size: 1.2rem;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
a{color: #428193;}
a:hover{text-decoration: none; color:#428193;}
.fs10{font-size: 1rem;}
.fs12{font-size: 1.2rem;}
.fs14{font-size: 1.4rem;}
.fs16{font-size: 1.6rem;}
.fs18{font-size: 1.8rem;}
.pointer{cursor: pointer;}
.bg-img-util{ background-repeat: no-repeat; background-size: cover; background-position: center center;}
.bg-blue{background-color: #428193;}
.bg-blue-opacity{background-color: rgba(66, 129, 147, 0.4);}
.bg-light-blue {background-color: #EBF7F7;}
.bg-light-gray {background-color: #F5F5F5;}
.text-blue{color: #428193;}
.text-light-blue{ color: #ADDDDE; }
.text-yellow{ color: #DDC036; }
button {background-color: transparent; border: none; cursor:pointer; text-align: left;}
button:focus{ outline:none; }

.text-white a{color: white;}
.border-left-yellow {border-left: 0.4rem solid #DDC036;}
.border-left-blue {border-left: 0.4rem solid #428193;}
.card-title{border-bottom: 0.5px solid lightgray;}
.card{border: unset;}
.card-header{background-color: white; box-shadow: 0.1rem 0.1rem 0.2rem 0.1rem lightgray; margin-bottom: 0.75rem; border: 0.1rem solid lightgray;}
[aria-expanded=true] div .fa-plus {transform: rotate(45deg);}
.fa-plus {height: 2.5rem;}

@media only screen and (max-width: 767px){
  .main-logo{max-height: 4rem;}
  .fs07{font-size: 0.7rem;}
  .fs09{font-size: 0.9rem;}
  .fs-sm-12{font-size: 1.2rem;}
  .fs-sm-10{font-size: 1rem;}

}
</style>
